<footer class="footer-container px-5 d-flex align-items-center justify-content-between h-100">
  <div class="footer-left d-flex align-items-center">
    <img [src]="logoSrc()" [alt]="'app.shared.logo_alt' | translate" class="logo" />
  </div>

  <div class="footer-middle d-flex align-items-center gap-4">
    <a routerLink="/" class="footer-link">Link Example 1</a>
    <a routerLink="/" class="footer-link">Link Example 2</a>
    <a routerLink="/" class="footer-link">Link Example 3</a>
  </div>

  <div class="footer-right d-flex align-items-center">
    <a routerLink="/" class="footer-link">Other Link</a>
  </div>
</footer>
